import { useState, useEffect } from 'react';

export function useScreenWidth(threshold = 640) {
  const [isMobileWidth, setIsMobileWidth] = useState(() => window.innerWidth <= threshold);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileWidth(window.innerWidth <= threshold);
    };

    handleResize(); // Set initial value

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [threshold]);

  return isMobileWidth;
}
